import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environments'
@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private http: HttpClient) { }


  allClietns(curtent :any , size:any){
    return this.http.get(`${environment.baseUrl}/client/all/?page=${curtent}&limit=${size}`)
    
  }

  searchClient(name:any,pageIndex:any,pageLimit:any){
    return this.http.get(`${environment.baseUrl}/client/search/?client_name=${name}&page=${pageIndex}&limit=${pageLimit}`)
  }
  getTypes(){
    return this.http.get(`${environment.baseUrl}/types/?name=owner`)
  }

  retiveClient(id:any){
    return this.http.get(`${environment.baseUrl}/client/?client_id=${id}`)
  }

  editClient(data:any){
    return this.http.put(`${environment.baseUrl}/client/`,data)
  }

  printCardForClient(id:any){
    return this.http.put(`${environment.baseUrl}/client/printCard/?client_id=${id}`,"")
  }

  all_unvirfyClient(current:any,size:any){
    return this.http.get(`${environment.baseUrl}/client/unverified?page=${current}&limit=${size}`)
  }

  verfiyClient(id:any){
    return this.http.put(`${environment.baseUrl}/client/verify/?client_id=${id}`,"")
  }
}
